/**
 * A community's public identifier as the API carries it.
 *
 * Opaque on purpose: the backend accepts both the legacy numeric id and the UUID `public_id`
 * during the HNS-228 migration, and the frontend only ever uses this value as a URL segment, a
 * cache key, or an equality comparison. Keeping it a string makes both forms behave identically
 * and removes the need for the frontend to know which one it holds.
 *
 * Never convert this to a number: a UUID becomes NaN silently. Enforced by
 * __tests__/noCommunityIdCoercion.test.ts.
 */
export type CommunityId = string;

/** Every API boundary normalises through here, so the switch to `publicId` has one place to touch. */
export const communityIdFromApi = (value: string | number): CommunityId => String(value).trim();

/** Lenient variant for input that may legitimately be absent: localStorage, route params, error payloads. */
export const toCommunityId = (value: string | number | null | undefined): CommunityId | null => {
  if (value === null || value === undefined) return null;
  const normalised = communityIdFromApi(value);
  return normalised === '' ? null : normalised;
};
